import type { CheckboxChangeEvent } from 'antd/es/checkbox';

import { Checkbox } from 'antd';
import { useAppDispatch, useAppSelector } from '@/hooks/redux';
import { selectCardPreferences, setCardPreferences } from '@/store/payment/paymentSlice';
import { useAllowRememberCard } from '@/hooks/profile';
import { InfoTooltip } from '@/components/common/InfoTooltip';
import { useRef } from 'react';
import { usePaymentGatewayProvider } from '@feature/payment/usePaymentGatewayProvider';

/**
 * Checkbox component to allow users to save their card details for future payments.
 * @see paymentSlice
 */
export const SolidgateCardPreferencesCheckboxes: RC = () => {
  const { isSolidgate } = usePaymentGatewayProvider();

  const dispatch = useAppDispatch();

  const shouldSaveCardRef = useRef<HTMLInputElement>(null);
  const isPrimaryRef = useRef<HTMLInputElement>(null);

  const cardPreferences = useAppSelector(selectCardPreferences);
  const { shouldSaveCard, isPrimary } = cardPreferences;

  const handleChangeSaveCardDetails = (e: CheckboxChangeEvent) => {
    const { name, checked } = e.target;
    dispatch(setCardPreferences({ ...cardPreferences, [String(name)]: checked }));
  };

  const allowRememberCard = useAllowRememberCard();

  if (!allowRememberCard || !isSolidgate) {
    return null; // Do not render the checkbox if saving card details is not allowed
  }

  return (
    <>
      <Checkbox name="shouldSaveCard" ref={shouldSaveCardRef} defaultChecked={shouldSaveCard} onChange={handleChangeSaveCardDetails}>
        Save card
        <InfoTooltip text={`You can disable this feature in the "Payment Cards" menu in your Profile settings.`} />
      </Checkbox>
      {shouldSaveCard && (
        <Checkbox name="isPrimary" ref={isPrimaryRef} defaultChecked={isPrimary} onChange={handleChangeSaveCardDetails}>
          Make as Primary card
        </Checkbox>
      )}
    </>
  );
};
